// src/components/ui/ErrorState.jsx
//
// Primitives layer. Promoted from Groups' own ErrorDisplay.jsx (the only
// place in the app that had a real error+retry block) so Dashboard/Stock
// Detail, which previously had zero error UI at all, can reuse the same
// pattern instead of a third bespoke implementation.
import React from 'react';
import { XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function ErrorState({ message, onRetry, showRetry = true }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-64 bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-500/20 rounded-2xl flex items-center justify-center p-8">
      <div className="text-center">
        <XCircle className="text-red-500 mx-auto mb-4" size={48} />
        <h3 className="text-xl font-semibold text-red-600 dark:text-red-400 mb-2">{t('common.somethingWentWrong')}</h3>
        <p className="text-red-600/80 dark:text-red-300/80 mb-4">{message}</p>
        {showRetry && (
          <button
            onClick={onRetry}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-all duration-300"
          >
            {t('common.tryAgain')}
          </button>
        )}
      </div>
    </div>
  );
}
